import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import user2 from "../../images/ic_no_person_photo.svg";
import { FaRegEdit } from "react-icons/fa";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { FaSearch } from "react-icons/fa";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const EndOfServiceApplication = () => {
  const [data, setData] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedgrade, setSelectedGrade] = useState("");
  const [selectedJob, setSelectedJobTitle] = useState("");
  const [Open, setOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [resetalldata, setResetallData] = useState(false);
  const [Division, setDivision] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [grade, setGrade] = useState(null);
  const [jobtitle, setJobTitle] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const today = new Date().toISOString().split("T")[0];

  const [dateOfJoin, setDateOfJoin] = useState(null);
  const [endOfService, setEndOfService] = useState(today);
  const [statusDataEOS, setStatusDataEOS] = useState(null);

  const [daysWorked, setDaysWorked] = useState(0);
  const [divisionMUI, setDivisionMUI] = useState("");
  const [searchdata, setSearchData] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchdata);
  const [jobMUI, setJobMUI] = useState("");
  const [gradeMUI, setGradeMUI] = useState("");
  const [reasonNotes, setReasonNotes] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [seperationMethod, setSeperationMethod] = useState("RESIGNATION");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const [base_url] = useState(base_url_from_axios_config);

  //     const lastIndex = currentPage * recordsPerPage;
  //   const firstIndex = lastIndex - recordsPerPage;
  //   const records = data?.slice(firstIndex, lastIndex);

  const formatDateWithExpiry = (date) => {
    if (!date) return <span>-</span>;

    const parsed = new Date(date);
    if (isNaN(parsed)) return <span>-</span>;

    const isExpired = parsed < new Date();

    return (
      <span className={isExpired ? "text-red-600 font-medium" : ""}>
        {parsed.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    );
  };

  const getData = async (empStatus) => {
    setLoader(true);
    try {
      // Read query parameters
      const jobTitleFromQuery = searchParams.get("jobTitle") || "";
      const gradeFromQuery = searchParams.get("grade") || "";
      const divisionFromQuery = searchParams.get("division") || "";

      // Validate query parameters against master data
      const isValidJobTitle =
        jobTitleFromQuery &&
        jobtitle?.some((job) => job.Description === jobTitleFromQuery);
      const isValidGrade =
        gradeFromQuery && grade?.some((g) => g.Description === gradeFromQuery);
      const isValidDivision =
        divisionFromQuery &&
        Division?.some((div) => div.Description === divisionFromQuery);

      // Update filter states if query parameters are valid and not already set
      if (isValidJobTitle && jobTitleFromQuery !== selectedJob) {
        setSelectedJobTitle(jobTitleFromQuery);
        setJobMUI(jobTitleFromQuery);
      }
      if (isValidGrade && gradeFromQuery !== selectedgrade) {
        setSelectedGrade(gradeFromQuery);
        setGradeMUI(gradeFromQuery);
      }
      if (isValidDivision && divisionFromQuery !== selectedDivision) {
        setSelectedDivision(divisionFromQuery);
        setDivisionMUI(divisionFromQuery);
      }

      // Determine API parameters
      const jobTitleParam = resetalldata
        ? "ALL"
        : isValidJobTitle
          ? jobTitleFromQuery
          : selectedJob || "ALL";
      const gradeParam = resetalldata
        ? "ALL"
        : isValidGrade
          ? gradeFromQuery
          : selectedgrade || "ALL";
      const divisionParam = resetalldata
        ? "ALL"
        : isValidDivision
          ? divisionFromQuery
          : selectedDivision || "ALL";
      // const searchParam = resetalldata ? "ALL" : searchdata || "ALL";
      // const searchType = searchdata && !resetalldata ? "FREETEXT" : "ALL";

      const searchParam = resetalldata ? "ALL" : debouncedSearch || "ALL";
      const searchType = debouncedSearch && !resetalldata ? "FREETEXT" : "ALL";

      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/${empStatus}/${searchParam}/${jobTitleParam}/${gradeParam}/${divisionParam}`,
      );

      if (response?.data) {
        setData(response.data);
        setFilteredData(response.data);

        // setCurrentPage(1); // Reset pagination
        if (
          (jobTitleFromQuery || gradeFromQuery || divisionFromQuery) &&
          !resetalldata
        ) {
          toast.info("Filters applied from previous page");
        }
      } else {
        toast.error("No employee data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (base_url && companyCode && jobtitle && grade && Division) {
      getData();
    }
  }, [
    base_url,
    companyCode,
    searchParams,
    searchdata,
    selectedJob,
    selectedgrade,
    selectedDivision,
    resetalldata,
    jobtitle,
    grade,
    Division,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchdata);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchdata]);

  useEffect(() => {
    if (dateOfJoin && endOfService) {
      const days = dayjs(endOfService).diff(dayjs(dateOfJoin), "day");
      setDaysWorked(days);
    } else {
      setDaysWorked(0);
    }
  }, [dateOfJoin, endOfService]);

  // Fetch profile picture
  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user2;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const onRecordSelect = (records) => {
    console.log("records:", records);
    setSelectedEmployee(records);
    getStatusData(records.EmpId);

    const formattedDate = records?.JoinDate
      ? records.JoinDate.split("T")[0]
      : "";

    setDateOfJoin(formattedDate);
  };

  const onSaveEOSApplication = async () => {
    const payload = [
      {
        CmpCode: companyCode,
        mode: "ENTRY",
        EmpID: selectedEmployee?.EmpId,
        Leave_key: seperationMethod,
        Leave_type: seperationMethod,
        Leave_Name: seperationMethod,
        ApplicationDate: today,
        FromDate: dateOfJoin,
        ToDate: endOfService,
        NoOfDays: daysWorked,
        Notes: reasonNotes,
        ApprovalStatus: "REQUESTED",
        ApprovedBy: "",
        ApprovalDate: null,
        RejoinDate: null,
        RejoinComments: "",
        Ticket: "0",
      },
    ];
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoEOS`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      const data = response.data;

      console.log("Saved EOS Application:", response.data);

      resetEOSApplication();
      setSnackbar({
        open: true,
        message: "EOS Application saved successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error while saving EOS application:", error);

      setSnackbar({
        open: true,
        message: "Failed to save EOS Application",
        severity: "error",
      });
    }
  };

  const getStatusData = async (empID) => {
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/EOSAPPSTATUS/${empID}/-`,
      );
      console.error("Success fetching EOS Status:", response);
      const data = response.data;
      setStatusDataEOS(data);
    } catch (error) {
      console.error("Error while fetching EOS Status:", error);
    }
  };

  const isFormValid =
    selectedEmployee &&
    seperationMethod &&
    reasonNotes &&
    dateOfJoin &&
    endOfService;

  const resetEOSApplication = () => {
    console.log("Reset EOS Application");
    setSelectedEmployee(null);
    setReasonNotes("");
    setDateOfJoin(null);
    setEndOfService(today);
    setSeperationMethod("RESIGNATION");
    setSearchData("");
  };

  useEffect(() => {
    if (searchdata) {
      const searchResult = data.filter(
        (item) =>
          item.EmpId?.toString()
            .toLowerCase()
            .includes(searchdata.toLowerCase()) ||
          item.Name?.toString()
            .toLowerCase()
            .includes(searchdata.toLowerCase()),
      );
      setFilteredData(searchResult);
    } else {
      setFilteredData(data);
    }
  }, [searchdata]);

  return (
    <div className="w-full min-h-screen">
      {/* Header */}
      <div className="flex items-center justify-between text-white px-4 py-3 rounded-t-lg">
        <div className="flex justify-left items-center mb-4 ">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>

          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              END OF SERVICE APPLICATION
            </span>
          </h6>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex gap-4  ">
        {/* Employee List */}
        <div className=" border p-3 rounded-md w-[80%] bg-white ">
          <div className=" flex  items-center justify-left gap-12 mb-2">
            <h3 className="text-[#2663EB] font-semibold mb-2">
              Employee List Filter
            </h3>

            <div className="bg-white w-[400px] flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search By ID or Name..."
                value={searchdata}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full bg-white outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {searchdata && (
                <button
                  onClick={() => setSearchData("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>

            {/* Filters */}
            {/* <div className="flex gap-2 mb-2"> */}
            {/* <select className="border px-2 py-1 text-sm">
              <option>Division</option>
            </select>

            <select className="border px-2 py-1 text-sm">
              <option>Dept</option>
            </select> */}
            {/* </div> */}
          </div>

          {/* Employee Table */}
          <div className="overflow-auto max-w-[84vw] max-h-[40vh]  border scrollbar-none bg-white">
            <table className="min-w-full border-separate border-spacing-0">
              <thead className="sticky top-0 z-10">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 font-medium text-left">Sl</th>
                  <th className="px-3 py-2 font-medium text-left">Emp Id</th>
                  <th className="px-3 py-2 font-medium text-left">Name</th>
                  <th className="px-3 py-2 font-medium text-left">Alt Id</th>
                  <th className="px-3 py-2 font-medium text-left">Status</th>
                  <th className="px-3 py-2 font-medium text-left">Job Title</th>
                  <th className="px-3 py-2 font-medium text-left">Division</th>
                  <th className="px-3 py-2 font-medium text-left">Grade</th>
                  <th className="px-3 py-2 font-medium text-left">Gender</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Nationality
                  </th>

                  {Open && (
                    <>
                      {[
                        "Bank Account",
                        "Bank Name",
                        "Agent Id",
                        "Current Address",
                        "Home Address",
                        "Home Airport",
                        "Work Mobile",
                        "Work Phone",
                        "Personal Phone",
                        "Personal Email",
                        "Passport Number",
                        "Passport Issue Date",
                        "Passport Expiry Date",
                        "Passport Place of Issue",
                        "Passport Country of Issue",
                        "Emirates Id",
                        "Expiry Date",
                        "Visa No",
                        "Visa Expiry Date",
                        "Insurance Number",
                        "Insurance Expiry Date",
                        "Driving License No",
                        "Driving License Expiry Date",
                        "Basic Pay",
                        "Allowances OT",
                        "Allowances NOT",
                        "Normal HRS",
                        "Hourly Wage",
                        "OT Rate",
                        "Spl OT Rate",
                        "Active",
                        "Memos",
                        "Notes",
                        "Salary Ac",
                        "Advance Ac",
                      ].map((col, i) => (
                        <th
                          key={i}
                          className="px-3 py-2 font-medium text-left whitespace-nowrap"
                        >
                          {col}
                        </th>
                      ))}
                    </>
                  )}
                </tr>
              </thead>

              <tbody className="text-sm text-gray-700">
                {filteredData?.map((d, i) => (
                  <tr
                    key={i}
                    className={`border  transition-colors duration-150 ${selectedEmployee == d ? "bg-blue-50 " : "hover:bg-gray-50"}`}
                    onClick={() => onRecordSelect(d)}
                  >
                    <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                      {i + 1}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border ">
                      {d?.EmpId}
                    </td>
                    {/* Name + Avatar */}
                    <td className="px-3 py-2 whitespace-nowrap border">
                      <div className="flex items-center gap-2">
                        <img
                          className="w-7 h-7 rounded-full object-cover"
                          src={
                            d.imagepath ? fetchProfilePic(d.imagepath) : user2
                          }
                          alt=""
                        />
                        <span>{d?.Name}</span>
                      </div>
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.AlternateID}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Status}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.JobTitle}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Division}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Grade}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Single}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Nationality}
                    </td>

                    {Open && (
                      <>
                        {[
                          d?.BankAccountNo,
                          d?.BankName,
                          d?.AgentID,
                          d?.CurrentAddress,
                          d?.HomeAddress,
                          d?.HomeAirport,
                          d?.WorkMobile,
                          d?.WorkPhone,
                          d?.PersonalPhone,
                          d?.PersonalEmail,
                          d?.PassportNo,
                          formatDateWithExpiry(d?.PassportIssueDate),
                          formatDateWithExpiry(d?.PassportExpiryDate),
                          d?.PassportPlaceofIssue,
                          d?.PassportCountryofIssue,
                          d?.EmiratesId,
                          formatDateWithExpiry(d?.EmiratesIdExpiryDate),
                          d?.VisaNo,
                          formatDateWithExpiry(d?.VisaExpiryDate),
                          d?.InsuranceNo,
                          formatDateWithExpiry(d?.InsuranceExpiryDate),
                          d?.DrivingLicenceNo,
                          formatDateWithExpiry(d?.DrivingLicenceExpiryDate),
                          d?.BasicPay,
                          d?.Allowances_OT,
                          d?.Allowances_NOT,
                          d?.NormalHrs,
                          d?.HourlyWage,
                          d?.OTrate,
                          d?.SplOtRate,
                          d?.Active,
                          d?.Memos,
                          d?.Notes,
                          d?.SalaryA,
                          d?.AdvanceAc,
                        ].map((val, index) => (
                          <td
                            key={index}
                            className="px-3 py-2 whitespace-nowrap border text-gray-600"
                          >
                            {val || "-"}
                          </td>
                        ))}
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* End Of Service Form */}
        <div className="bg-white rounded-md border p-4 w-[20%]">
          <div className="grid grid-cols-1 gap-4 text-sm">
            <div>
              <label>Date of Join</label>
              <input
                type="date"
                className="cursor-not-allowed border w-full px-2 py-1"
                // onChange={(e) => setDateOfJoin(e.target.value)}
                value={dateOfJoin}
                disabled
              />
            </div>

            <div className="text-red-600 font-bold">{daysWorked} DAYS</div>

            <div>
              <label>End of Service Date</label>
              <input
                type="date"
                className="border w-full px-2 py-1"
                onChange={(e) => setEndOfService(e.target.value)}
                value={endOfService}
              />
            </div>

            <div>
              <label>Seperation Method</label>
              <select
                onChange={(e) => setSeperationMethod(e.target.value)}
                className="border w-full px-2 py-1"
              >
                <option value="RESIGNATION">RESIGNATION</option>
                <option value="TERMINATION">TERMINATION</option>
              </select>
            </div>
          </div>

          {/* Reason */}
          <div className="mt-4">
            <label className="text-[#2663EB] font-semibold">Reason</label>
            <textarea
              className="w-full border p-2 h-24"
              placeholder="Enter reason..."
              onChange={(e) => setReasonNotes(e.target.value)}
            />
          </div>

          <div>
            <Tooltip
              title={
                !isFormValid
                  ? "Please select employee, separation method , date of join , end of service date and reason"
                  : ""
              }
              arrow
            >
              <button
                onClick={onSaveEOSApplication}
                disabled={!isFormValid}
                className={`w-full px-6 py-2 text-sm font-semibold rounded-lg transition
    ${
      !isFormValid
        ? "bg-gray-400 cursor-not-allowed text-white"
        : "bg-[#2663EB] hover:bg-blue-700 text-white"
    }`}
              >
                SAVE
              </button>
            </Tooltip>
          </div>

          {/* Status Monitor */}
          {/* <div className="mt-5">
            <div className="flex justify-between items-center">
              <h3 className="text-red-500 font-semibold">Status Monitor</h3>

              <button className="bg-gray-500 text-white px-4 py-1 text-sm">
                EDIT
              </button>
            </div>

            <div className="border mt-2 h-40 bg-gray-100"></div>
          </div> */}
        </div>
      </div>

      {/* Employee Info */}
      {selectedEmployee && (
        <div className="flex justify-between items-start  rounded-md mt-4 ">
          <div className="flex  justify-between items-center w-[40%] bg-blue-50 p-4 border rounded-md">
            <div className="flex gap-4 items-center">
              <img
                src={
                  selectedEmployee?.imagepath
                    ? fetchProfilePic(selectedEmployee.imagepath)
                    : user2
                }
                alt="employee"
                className="w-20 h-20 object-cover "
              />
              {/* <img
            className="w-7 h-7 rounded-full object-cover"
            src={d.imagepath ? fetchProfilePic(d.imagepath) : user2}
            alt=""
          /> */}
              <div className="text-sm space-y-1">
                <div>
                  <span className="text-gray-600">Employee ID</span>
                  {" : "}
                  <span className="font-semibold">
                    {selectedEmployee?.EmpId || "-"}
                  </span>
                </div>

                <div>
                  <span className="text-gray-600">Name</span>
                  {" : "}
                  <span className="font-semibold">
                    {selectedEmployee?.Name || "-"}
                  </span>
                </div>

                {/* <div>
              <span className="text-gray-600">Department</span>{" "}
              <span>Calender days</span>
            </div> */}

                <div>
                  <span className="text-gray-600">Job Title</span>{" "}
                  <span className="font-semibold">
                    {" "}
                    {selectedEmployee?.JobTitle || "-"}
                  </span>
                </div>
                <div>
                  <span className="text-gray-600">Divsion</span>
                  {" : "}
                  <span className="font-semibold">
                    {" "}
                    {selectedEmployee?.Division || "-"}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <p className="text-gray-600">Available Days</p>
              <p className="text-xl font-bold text-teal-700">0</p>
              <p className="text-xs text-teal-600">DAYS</p>
            </div>
          </div>

          <div className="h-[260px] overflow-auto w-[60%] ml-4">
            {/* <h3 className="text-[#2663EB] font-semibold mb-2">
              Status Monitor
            </h3> */}
            <table className="min-w-full h-[200px] border-separate border-spacing-0">
              <thead className="sticky top-0 z-10">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 font-medium text-left">Sl</th>
                  <th className="px-3 py-2 font-medium text-left">EOS Type</th>
                  <th className="px-3 py-2 font-medium text-left">Join Date</th>
                  <th className="px-3 py-2 font-medium text-left">End Date</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Total Days
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Status</th>
                </tr>
              </thead>
              <tbody className="text-sm text-gray-700 h-[200px]">
                {statusDataEOS?.map((item, i) => (
                  <tr
                    key={i}
                    className={`border  transition-colors duration-150 hover:bg-gray-50`}
                  >
                    <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                      {item.serialcode}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border ">
                      {item?.EOS_Type}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(item["JOIN-DT"]).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(item["END-DATE"]).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {item?.TOTAL_DAYS}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {item?.Status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default EndOfServiceApplication;
